import React, { useEffect, useState } from "react";
import "./ApprovedTransactions.css";
import { NavLink, useNavigate } from "react-router-dom";

const ApprovedTransactions = () => {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  const [stats, setStats] = useState({
    approved: 0,
    totalApprovedAmount: 0,
  });

  

  const fetchApprovedTransactions = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        "/backend/admin/transactions/approved",
        {
          method: "POST",
          credentials: "include",
        }
      );

      const data = await response.json();

      if (response.ok) {
        const approvedTransactions = data.approved || [];

        const totalApprovedAmount = approvedTransactions.reduce(
          (sum, item) => sum + Number(item.amount_paid || 0),
          0
        );

        setTransactions(approvedTransactions);

        setStats({
          approved: approvedTransactions.length,
          totalApprovedAmount,
        });
      } else {
        alert(data.error || "Unable to fetch approved transactions.");
      }
    } catch (err) {
      console.error(err);
      alert("Server Error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApprovedTransactions();
  }, []);

  

  const handleLogout = () => {
    navigate("/alumni-login", { replace: true, state: { loggedOut: true } });
  };

  return (
    <div className="admin-dashboard">

      

      <aside className="admin-sidebar">

        <div className="admin-sidebar-header">
          <h2>Admin Panel</h2>
        </div>

        <nav className="admin-sidebar-menu">

          <NavLink
            to="/admin-dashboard"
            className="admin-menu-item"
          >
            Pending Transactions
          </NavLink>

          <NavLink
            to="/approved-transactions"
            className="admin-menu-item"
          >
            Approved Transactions
          </NavLink>

          <NavLink
            to="/rejected-transactions"
            className="admin-menu-item"
          >
            Rejected Transactions
          </NavLink>

          <div className="admin-menu-divider"></div>

          <button
            className="admin-logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>

        </nav>

      </aside>

   
      <main className="admin-main">

        <div className="admin-header">

          <h1>Approved Transactions</h1>

          <p>
            List of all approved payment transactions.
          </p>

        </div>

      

        <div className="admin-cards">

          <div className="admin-card">

            <h4>Total Approved</h4>

            <h2>{stats.approved}</h2>

          </div>

          <div className="admin-card">

            <h4>Total Amount</h4>

            <h2>
              ₹ {stats.totalApprovedAmount.toLocaleString()}
            </h2>

          </div>

        </div>

       

        <div className="admin-table-container">

          <table>

            <thead>

              <tr>

                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Donor</th>
                <th>Fund</th>
                <th>Installment</th>
                <th>Due Amount</th>
                <th>Amount Paid</th>
                <th>Due Date</th>
                <th>Approved At</th>
                <th>Status</th>

              </tr>

            </thead>

            <tbody>

              {loading ? (

                <tr>

                  <td
                    colSpan="12"
                    className="admin-center"
                  >
                    Loading approved transactions...
                  </td>

                </tr>

              ) : transactions.length === 0 ? (

                <tr>

                  <td
                    colSpan="12"
                    className="admin-center"
                  >
                    No Approved Transactions Found
                  </td>

                </tr>

              ) : (

                transactions.map((item) => (

                  <tr key={item.id}>

                    <td>{item.id}</td>

                    <td>{item.fullname}</td>

                    <td>{item.email}</td>

                    <td>{item.phone}</td>

                    <td>{item.donor_name}</td>

                    <td>{item.fund_type}</td>

                    <td>#{item.installment_no}</td>

                    <td>
                      ₹ {Number(item.due_amount).toLocaleString()}
                    </td>

                    <td>
                      ₹ {Number(item.amount_paid).toLocaleString()}
                    </td>

                    <td>
                      {item.due_date
                        ? new Date(item.due_date).toLocaleDateString()
                        : "-"}
                    </td>

                    <td>
                      {item.approved_at
                        ? new Date(item.approved_at).toLocaleString()
                        : "-"}
                    </td>

                    <td>

                      <span
                        className={`admin-status ${String(
                          item.approval_status
                        ).toLowerCase()}`}
                      >
                        {item.approval_status}
                      </span>

                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

      </main>

    </div>
  );
};

export default ApprovedTransactions;